import { useCallback } from 'react';
import { client } from '../graphql/client';
import { CURRENT_USER_OPERABLE_WAREHOUSE_IDS } from '../graphql/queries/currentUserOperableWarehouseIds';
import { getUserInfo } from '../utils/auth';

/**
 * 从服务端触发当前用户可操作仓库 ID 写入 Redis。
 * 接口失败时 throw，由调用方决定如何处理。
 */
export function useFetchWarehouseIds() {
    const fetchWarehouseIds = useCallback(async (): Promise<void> => {
        const userInfo = getUserInfo();
        if (!userInfo?.account?.id) return;

        await client.query({
            query: CURRENT_USER_OPERABLE_WAREHOUSE_IDS,
            fetchPolicy: 'network-only',
        });
    }, []);

    return { fetchWarehouseIds };
}
